export default __webpack_public_path__ + "static/media/training3.5907d69d.jpg";